import mrModalReducer, { NAME as mrModalName } from '@hixme/modal'
import { combineReducers } from 'redux'
import { reducer as form } from 'redux-form'

/* Utility modules */
import { reducer as authui } from '@hixme/auth-ui'
import modal from 'modules/app-core/modal'
import notificationManager from 'modules/app-core/notification-manager'
import { reducer as layout } from 'modules/layout'

import census from 'store/modules/census'
import companies from 'store/modules/companies'
import employee from 'store/modules/employee'
import persons from 'store/modules/persons'
import userSession from 'store/modules/user-session'

import quickSight from 'components/QuicksightDashboard/module'

// ========================================================
// The below should be migrated to be async with injectReducer
// ========================================================

import gateway from 'modules/redux-gateway'
import waiter from 'redux-waiter'

/* Prospect list, profile */
import profile from 'modules/prospect-profile'

/* employee */
import benefitsEffectiveDates from 'modules/benefits-effective-dates'
import locations from 'modules/locations'

/* router location */
import activityLogPopupSlice from '../modules/activity-log-service/activityLogPopupSlice'
import paymentReconciliationSlice from '../modules/finance/payment-reconciliation/paymentReconciliationSlice'
import locationReducer from './location'

/* enrollment platform */
import applicationQueueReducer from '../enrollment-platform/pages/ApplicationQueue/slices/applicationQueueSlice'

export const makeRootReducer = (asyncReducers) =>
  combineReducers({
    // Add sync reducers here
    // module reducers
    authui,
    form,
    layout,
    location: locationReducer,
    [benefitsEffectiveDates.constants.NAME]: benefitsEffectiveDates.reducer,
    [companies.constants.NAME]: companies.reducer,
    [modal.constants.NAME]: modal.reducer,
    [mrModalName]: mrModalReducer,
    [notificationManager.constants.NAME]: notificationManager.reducer,
    [census.constants.NAME]: census.reducer,
    [employee.constants.NAME]: employee.reducer,
    [persons.constants.NAME]: persons.reducer,
    [userSession.constants.NAME]: userSession.reducer,

    // route reducers to be migrated to use injectReducer
    [profile.constants.NAME]: profile.reducer,
    [locations.constants.NAME]: locations.reducer,

    [gateway.constants.NAME]: gateway.reducer,
    [waiter.constants.NAME]: waiter.reducer,

    [quickSight.constants.NAME]: quickSight.reducer,

    // redux-toolkit
    activityLogPopupSlice: activityLogPopupSlice,
    applicationQueue: applicationQueueReducer,
    paymentReconciliation: paymentReconciliationSlice,

    ...asyncReducers,
  })

export const injectReducer = (store, { key, reducer }) => {
  store.asyncReducers[key] = reducer // eslint-disable-line
  store.replaceReducer(makeRootReducer(store.asyncReducers))
}

export default makeRootReducer
